module.exports = __webpack_public_path__ + "static/media/blank-portrait-box.24b7bf81.png";